<script>
import Validation from '@/plugins/validation'
import { Input, AutocompleteSelect } from '@/components/formelements'
import { mapState } from 'vuex'

export default {
  name: 'PromotionGroups',
  props: ['id'],
  async mounted() {
    await this.$store.dispatch('promotionGroups/GET_PROMOTIONGROUPS_RETAILER_ID')
    await this.$store.dispatch('promotionGroups/GET_PROMOTION_TYPES')
    this.dataReceived = true
  },
  data() {
    return {
      ...Validation,
      newPromoGroup: true,
      items: [
        {
          text: 'active',
          value: "1",
        },
        {
          text: 'deleted/inactive',
          value: "901",
        },
      ],
      dataReceived: false
    }
  },
  components: {
    Input,
    AutocompleteSelect,
  },
  computed: {
    ...mapState({
      orgRetailerInfo: state => state.retailer.orgRetailerInfo,
      statusTypes: state => state.search.statusTypes,
      tabelHeaders: state => state.promotionGroups.headers,
      promoTypes: state => state.promotionGroups.promoTypes,
      allPromoGroups: state => state.promotionGroups.allPromoGroups,
      updatedBy: state => state.promotionGroups.updatedBy,
      updatedDate: state => state.promotionGroups.updatedDate
    }),
    promoTypesLayout() {
      return this.promoTypes.map( type => {
        return { text: type.Description, value: type.ID }
      })
    },
  },
  methods: {
    getRowStatus: function(statusCode) {
      const status = this.statusTypes.filter( type => type.ID == statusCode)
      return status[0].Name
    },
    getPromotype(id){
      const type = this.promoTypes.filter( type => type.ID == id)
      return type[0].Description
    },
    async getPromoGroup(id){
      this.newPromoGroup = false
      await this.$store.dispatch('promotionGroups/GET_PROMO_GROUP', id)
    },
    async updatePoromo(){
      if (this.$refs.promoForm.validate()){
        if (this.newPromoGroup){
          await this.$store.dispatch('promotionGroups/INSERT_PROMO_GROUP')
        } else {
          await this.$store.dispatch('promotionGroups/UPDATE_PROMO_GROUP')
        }
        this.$store.dispatch('promotionGroups/RESET')
        await this.$store.dispatch('promotionGroups/GET_PROMOTIONGROUPS_RETAILER_ID')
        this.newPromoGroup = true
      }
    }
  }
}
</script>

<template>
  <v-container fluid>
    <v-row>
      <router-link style="text-decoration: none" class="pa-5" :to="{ name: 'Retailer', params: { id: id } }"> 
        Retailer: {{ orgRetailerInfo.Name }} ({{ id }}) 
      </router-link>
    </v-row>
    <v-row>
      <v-col class="pl-6" cols="12">
        <v-form ref="promoForm">
          <v-row>
            <v-col cols="12" sm="6" >
              <AutocompleteSelect :rules="[...required]" :disabled="!newPromoGroup" form="promotionGroups" field="promotionType" :items="promoTypesLayout" label="Promotion Type" />
            </v-col>
            <v-col cols="12" sm="6">
              <Input :rules="[...required]" form="promotionGroups" field="group" label="Group" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              Last updated By <br/> {{ updatedBy }}
            </v-col>
            <v-col cols="6">
              Last Updated Date <br/> {{ updatedDate }}
            </v-col>
          </v-row>  
          <v-row>
            <v-col cols="6">
              <AutocompleteSelect :rules="[...required]" form="promotionGroups" field="status" :items="items" label="Row Status Type" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn @click="updatePoromo" width="125px" depressed color="primary">
                <v-icon left>mdi-content-save</v-icon> Save
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card >
          <v-data-table
            v-if="dataReceived"
            :headers="tabelHeaders"
            :items="allPromoGroups"
            :items-per-page="10"
          >
            <template v-slot:item.ID=" { item }" >
              <span style="cursor: pointer" class="primary--text" @click="getPromoGroup(item.ID)">
                {{item.ID}}
              </span>
            </template>
            <template v-slot:item.PromotionTypeID=" { item }" >
              <span>
                {{ getPromotype(item.PromotionTypeID) }}
              </span>
            </template>
            <template v-slot:item.RowStatus=" { item }" >
              <span>
                {{ getRowStatus(item.RowStatus) }}
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
